module.exports = __webpack_public_path__ + "img/FSE-IG256-Profesionais40.d907e394.png";